import { render, staticRenderFns } from "./equip.vue?vue&type=template&id=2fc0f57c&scoped=true"
import script from "./equip.vue?vue&type=script&lang=js"
export * from "./equip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0f57c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc0f57c')) {
      api.createRecord('2fc0f57c', component.options)
    } else {
      api.reload('2fc0f57c', component.options)
    }
    module.hot.accept("./equip.vue?vue&type=template&id=2fc0f57c&scoped=true", function () {
      api.rerender('2fc0f57c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/agent/equip.vue"
export default component.exports